import * as React from 'react'

import { observer } from 'mobx-react'

import { PanesPad } from 'modules/core/components/PanesPad'
import { Tabs } from 'modules/core/components/Table'
import type { TabType } from 'modules/core/components/Table'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'

import Activity from '../Activity'
import Overview from '../Overview'
import { useComplaint } from '../complaintContext'

export type TabIds = 'overview' | 'activity'

interface Props {
  tab: TabType<TabIds>
  isSelected: boolean
  read: boolean
  borderTop: boolean
  onDeleteComplaint: () => void
}

function Tab({ tab, isSelected, read, borderTop, onDeleteComplaint }: Props) {
  const { complaint } = useComplaint()

  if (!complaint) throw new Error('Complaint not found')

  const { performAction: updateStatus } = useAsyncAction(
    async () => {
      const value = await complaint.rpc('update_read_at', {
        complaint_id: complaint.id,
        read_at: true,
      })
      complaint.set(value)
    },
    {
      successFlash: false,
    }
  )
  React.useEffect(() => {
    if (isSelected && tab.id === 'activity' && !read) {
      updateStatus()
    }
  }, [isSelected, read, tab.id, updateStatus])

  return (
    <Tabs.Panel tab={tab} borderTop={borderTop} isSelected={isSelected} key={tab.id}>
      <PanesPad>
        {tab.id === 'overview' && <Overview onDeleteComplaint={onDeleteComplaint} />}
        {tab.id === 'activity' && <Activity />}
      </PanesPad>
    </Tabs.Panel>
  )
}

export default observer(Tab)
